import { combineReducers } from "@reduxjs/toolkit";
import adminAuthSlice from "./adminAuth/adminAuthSlice";
import jobSeekerSlice from "./jobSeeker/jobSeekerSlice";
import companyListSlice from "./companyList/companyListSlice";
import messageTemplateSlice from "./messageTemplate/messageTemplateSlice";
import employerTemplateSlice from "./employerTemplate/employerTemplateSlice";
import jobPostListSlice from "./jobPostList/jobPostListSlice";

import logSlice from "./log/logSlice";
import commonSlice from "./common/commonSlice";
import jobPromotionSlice from "./jobPromotion/jobPromotionSlice";
import linkedinPromotionSlice from "./linkedinPromotion/linkedinPromotionSlice";
import candidateTransferSlice from "./candidateTransfer/candidateTransferSlice";
import whatsappSlice from "./whatsapp/whatsappSlice";

const combinedReducer = combineReducers({
  adminAuth: adminAuthSlice,
  jobSeeker: jobSeekerSlice,
  companyList: companyListSlice,
  messageTemplate: messageTemplateSlice,
  employerTemplate: employerTemplateSlice,
  jobPostList: jobPostListSlice,
  log: logSlice,
  common: commonSlice,
  jobPromotion: jobPromotionSlice,
  linkedinPromotion: linkedinPromotionSlice,
  candidateTransfer: candidateTransferSlice,
  whatsapp: whatsappSlice,
});

const rootReducer = (state, action) => {
  return combinedReducer(state, action);
};

export default rootReducer;
